// extracted by mini-css-extract-plugin
export default {"bottomBar":"Bottombar_bottomBar__3lQd2","icon":"Bottombar_icon__4aBak","container":"Bottombar_container__EG+9k","section":"Bottombar_section__DJBcJ"};